<template>
    <div class="floor-list">
        <elementary-section shadow :light="index % 2 === 0 ? false : true" :key="floor.id"
                            v-for="(floor, index) in floors">
            <div class="container">
                <floor-item :floor="floor"/>
            </div>
        </elementary-section>
    </div>
</template>

<script>
import FloorItem from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Floor/FloorItem';
import ElementarySection from '@/components/Content/ElementarySection';

export default {
    name:       'FloorList',
    components: {ElementarySection, FloorItem},
    computed:   {
        floors() {
            return this.$store.getters['projects/project/floorPlan/floors']
        }
    }
}
</script>
